module.exports = __webpack_public_path__ + "svg/dice-yellow.svg?7f53e32cca5b3ad442257f57877a5650";